var React = require('react');

function CodeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 15.1662L18.17 11.9963L15 8.82625L16.41 7.40625L21 11.9963L16.41 16.5762L15 15.1662ZM9 8.82625L5.83 11.9962L9 15.1662L7.59 16.5862L3 11.9962L7.59 7.41625L9 8.82625Z","fill":"currentColor"}));
}

CodeIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CodeIcon;

CodeIcon.default = CodeIcon;
